import { ActionTree } from 'vuex';
import moment from 'moment';
import { FETCH_HISTORY, FETCH_FILTERS_META, HISTORY_NAVIGATION, UPDATE_NAVIGATION, SET_ERROR, REINIT, UPDATE_HISTORY_STATE, HistoryState, SET_FILTER_CATEGORIES, CLEAR_FILTERS } from './types';
import { HistorySearchApiCaller as HistorySearchApi } from './callers';

const actions: ActionTree<HistoryState, Record<string, never>> = {
  [REINIT]({ commit }): void {
    commit(REINIT);
  },
  [SET_ERROR]({ commit }, payload) : void {
    commit(SET_ERROR, payload);
  },
  [UPDATE_NAVIGATION]({ commit }, payload): void {
    commit(UPDATE_NAVIGATION, payload);
  },
  [HISTORY_NAVIGATION]({ commit }, payload): void {
    commit(HISTORY_NAVIGATION, payload);
  },
  async [FETCH_FILTERS_META]({ commit }): Promise<void> {
    commit(UPDATE_HISTORY_STATE, {
      view: 'filters',
      stateKey: 'loading',
      stateValue: true
    });
    commit(UPDATE_HISTORY_STATE, {
      view: 'filters',
      stateKey: 'fetched',
      stateValue: false
    });
    commit(UPDATE_HISTORY_STATE, {
      view: 'filters',
      stateKey: 'error',
      stateValue: false
    });
    return HistorySearchApi.getFilterMetaHistory()
      .then((filters) => {
        commit(FETCH_FILTERS_META, filters.historyTypes);
        commit(UPDATE_HISTORY_STATE, {
          view: 'filters',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_HISTORY_STATE, {
          view: 'filters',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_HISTORY_STATE, {
          view: 'filters',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((err) => {
        commit(SET_ERROR, err.message);
        commit(UPDATE_HISTORY_STATE, {
          view: 'filters',
          stateKey: 'error',
          stateValue: true
        });
        commit(UPDATE_HISTORY_STATE, {
          view: 'filters',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_HISTORY_STATE, {
          view: 'filters',
          stateKey: 'loading',
          stateValue: false
        });
      });
  },
  async [FETCH_HISTORY]({ getters, commit, rootGetters }, navigation): Promise<void> {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    commit(UPDATE_HISTORY_STATE, {
      view: 'history',
      stateKey: 'loading',
      stateValue: true
    });
    commit(UPDATE_HISTORY_STATE, {
      view: 'history',
      stateKey: 'fetched',
      stateValue: false
    });
    commit(UPDATE_HISTORY_STATE, {
      view: 'history',
      stateKey: 'error',
      stateValue: false
    });
    let payload = getters.getSelectedFilters;
    if (navigation.filters) {
      payload = { ...navigation.filters };
    }
    if (navigation) {
      payload.start = navigation.start;
      payload.size = navigation.size;
    }
    return HistorySearchApi
      .searchHistory(
        navigation.size,
        navigation.start,
        master.id,
        payload.deviceId?.split(','),
        payload.identifierMatchers,
        payload.dtco_ids,
        payload.plateNumber,
        payload.fromto,
        moment().unix(),
        payload.historyType,
        payload.device_types,
        payload.subCategories?.split(','),
        undefined
      )
      .then((res) => {
        commit(FETCH_HISTORY, res);
        commit(UPDATE_HISTORY_STATE, {
          view: 'history',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_HISTORY_STATE, {
          view: 'history',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_HISTORY_STATE, {
          view: 'history',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
        commit(UPDATE_HISTORY_STATE, {
          view: 'history',
          stateKey: 'error',
          stateValue: true
        });
        commit(UPDATE_HISTORY_STATE, {
          view: 'history',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_HISTORY_STATE, {
          view: 'history',
          stateKey: 'loading',
          stateValue: false
        });
      });
  },
  [SET_FILTER_CATEGORIES]({ commit }, payload): void {
    commit(SET_FILTER_CATEGORIES, payload);
  },
  [CLEAR_FILTERS]({ commit }): void {
    commit(CLEAR_FILTERS);
  }
};
export default actions;
